import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import './i18n/i18n';
import { env, envPrefixedTitle } from './config/env';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');
document.title = envPrefixedTitle(document.title, env.envLabel);
createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
